/* Compare: shared state. Handles live in localStorage so a selection made
   on the collection grid survives the click through to a product page.
   Per-browser only - it will not follow a customer to another device. */
window.croCompare = (function () {
  var KEY = 'aroma:compare';
  var MAX = 4;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('compare:changed', { detail: read() }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i > -1) { l.splice(i, 1); write(l); return false; }
    if (l.length >= MAX) return null;
    l.push(h); write(l); return true;
  }
  function clear() { write([]); }

  return { read: read, has: has, toggle: toggle, clear: clear, MAX: MAX };
})();
